export const selectIsDashboardLoading = (state) => {
    const widgetStates = state.dashboardWidgetsLoading || {};
    return Object.values(widgetStates).some(Boolean);
  };